import { forwardRef, type Ref, type SVGProps } from "react";
const IconHeartFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M27 5.6a7.91 7.91 0 0 0-10.49.87l-.51.47-.46-.47A7.91 7.91 0 0 0 5.05 5.6a8 8 0 0 0-.76 11.92l.65.66L15.29 28.7a1 1 0 0 0 1.42 0l10.35-10.52.65-.66A8 8 0 0 0 27 5.6" />
  </svg>
);
const ForwardRef = forwardRef(IconHeartFilledSVG);
ForwardRef.displayName = "IconHeartFilled";
export { ForwardRef as IconHeartFilled };
